module.exports = __webpack_public_path__ + "static/media/part-19.fb6fcdec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-19.jpg
// module id = 952
// module chunks = 0